import { Component, Suspense, type ErrorInfo, type ReactNode } from 'react';
import { errorMessage } from '../lib/errors';

interface State { error?: unknown }

class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = {};
  static getDerivedStateFromError(error: unknown): State { return { error }; }
  componentDidCatch(error: unknown, info: ErrorInfo) { console.error('[extension]', error, info.componentStack); }
  render() {
    if (this.state.error !== undefined) {
      return <div className="vc-error" role="alert">Extension crashed: {errorMessage(this.state.error)}</div>;
    }
    return this.props.children;
  }
}

/** Error boundary + suspense around every extension so a crash is visible, not a blank iframe. */
export function Shell({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <Suspense fallback={<p className="vc-muted">Loading…</p>}>{children}</Suspense>
    </ErrorBoundary>
  );
}
